import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NgxPermissionsGuard } from 'ngx-permissions';
import { AgmCoreModule } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { NgxCarouselModule } from 'ngx-carousel';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { SharedModule } from '../../../../../../core/modules/shared.module';
import { FuseWidgetModule } from '../../../../../../core/components/widget/widget.module';
import { AddEditSchoolYearComponent } from './add-edit-school-year.component';
import { AddEditDivisionComponent } from '../add-edit-division/add-edit-division.component';
import { CourseYearService } from '../../../../../services/cour-years/course-year.service';

const routes = [
    {
        path: 'pages/management/schoolyear/add',
        component: AddEditSchoolYearComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_HOME',
                redirectTo: '/pages/errors/error-403'
            },
            mode : 'add'
        }
    },
    {
        path: 'pages/management/schoolyear/view/:id',
        component: AddEditSchoolYearComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_HOME',
                redirectTo: '/pages/errors/error-403'
            },
            mode : 'view'
        }
    },
    {
        path: 'pages/management/schoolyear/edit/:id',
        component: AddEditSchoolYearComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_HOME',
                redirectTo: '/pages/errors/error-403'
            },
            mode : 'edit'
        }
    }
];

@NgModule({
    declarations: [
        AddEditSchoolYearComponent,
        AddEditDivisionComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        AgmCoreModule,
        AgmSnazzyInfoWindowModule,
        NgxCarouselModule,
        FuseWidgetModule,
        NgxChartsModule
    ],
    exports: [
        AddEditSchoolYearComponent
    ],
    providers: [
        AddEditSchoolYearComponent,
        CourseYearService
    ],
    entryComponents: [
        AddEditDivisionComponent
    ]
})

export class AddEditSchoolYearModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/schoolyear/add-edit-school-year/add-edit-school-year.module.ts